import { Component, computed, inject } from '@angular/core';
import { ChannelService, ParameterService } from '@frontend/frontendlib';

@Component({
  selector: 'app-choosepayment-paymentoverview',
  templateUrl: './choosepayment-paymentoverview.component.html',
  styleUrls: ['./choosepayment-paymentoverview.component.css'],
})
export class ChoosepaymentPaymentoverviewComponent {
  
  private readonly channelService = inject(ChannelService);
  public readonly parameterService = inject(ParameterService);
  public referenzText = computed(() => this.channelService.getReferenceText());
}
